import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Outdoor_Cameras/IN-7011_HD/NavButtons';
import CompareFlyout from 'components/Products/Compare/CompareOutdoorFlyout';
import TableFeatures from 'components/Outdoor_Cameras/IN-7011_HD/TableFeatures';
import OutdoorData from 'components/Products/Flyouts/Graphs/OutdoorGraphsFlyout';
import RadarGraphCard from 'components/Products/RadarGraphs/in7011-radargraph-grid';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  NavButtons,
  CompareFlyout,
  TableFeatures,
  OutdoorData,
  RadarGraphCard,
  BreadCrumbs,
  SEOHelmet,
  React
};